import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import { getSolarEdgeOverviewApi, getSolarEdgePlantInvertersApi } from '@/api/otherSources';

import dayjs from 'dayjs';
var LEVEL_ORDER = {
  fault: 0,
  warn: 1,
  info: 2
};
export default {
  name: 'SolarEdgePanel',
  data: function data() {
    return {
      loading: false,
      plants: [],
      errors: [],
      fetchedAt: null,
      stale: false,
      daytime: true,
      opened: {},
      detail: {},
      detailLoading: {},
      detailError: {}
    };
  },
  computed: {
    fetchedAtText: function fetchedAtText() {
      return this.fetchedAt ? dayjs(this.fetchedAt).format('MM/DD HH:mm') : '';
    },
    /**
     * 「斷流」跟「日落後不再更新」都會讓畫面停住，但該做的事完全相反：
     * 前者要去查抓取排程或對方 API，後者什麼都不用做。
     */
    statusNote: function statusNote() {
      if (this.stale) {
        return {
          text: '資料停止更新',
          variant: 'danger',
          hint: '白天超過一小時未收到新資料，請洽資訊人員'
        };
      }
      if (!this.daytime) {
        return {
          text: '日落後不再更新',
          variant: 'secondary',
          hint: '每日 19:00 至隔日 06:00 不更新，日落後發電資料不再變動'
        };
      }
      return null;
    },
    allAlerts: function allAlerts() {
      return this.plants.flatMap(function (p) {
        return p.alerts.map(function (a) {
          return _objectSpread(_objectSpread({}, a), {}, {
            plantName: p.name
          });
        });
      }).sort(function (a, b) {
        return LEVEL_ORDER[a.level] - LEVEL_ORDER[b.level];
      });
    },
    faultCount: function faultCount() {
      return this.allAlerts.filter(function (a) {
        return a.level === 'fault';
      }).length;
    },
    warnCount: function warnCount() {
      return this.allAlerts.filter(function (a) {
        return a.level === 'warn';
      }).length;
    },
    kpis: function kpis() {
      var _this = this;
      var sum = function sum(fn) {
        return _this.plants.reduce(function (s, p) {
          return s + (fn(p) || 0);
        }, 0);
      };
      var capacity = sum(function (p) {
        return p.capacity;
      });
      var energy = sum(function (p) {
        return p.energyToday;
      });
      return [{
        label: '案場數',
        value: this.plants.length,
        unit: ' 座',
        tone: ''
      }, {
        label: '今日總發電',
        value: this.fmt(energy, 1),
        unit: ' kWh',
        tone: ''
      }, {
        label: '即時總發電功率',
        value: this.fmt(sum(function (p) {
          return p.instantPower;
        }), 1),
        unit: ' kW',
        tone: ''
      }, {
        label: '等效小時',
        value: capacity ? this.fmt(energy / capacity, 2) : '—',
        unit: ' h',
        tone: ''
      }, {
        label: '今日 PR',
        value: 'NA',
        unit: '',
        tone: '',
        hint: '本案場未設置日照計，無法計算 PR'
      }, {
        label: '故障（紅燈）',
        value: this.faultCount,
        unit: ' 件',
        tone: this.faultCount ? 'is-fault' : ''
      }];
    }
  },
  methods: {
    load: function load() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getSolarEdgeOv, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return getSolarEdgeOverviewApi();
              case 4:
                _yield$getSolarEdgeOv = _context.sent;
                data = _yield$getSolarEdgeOv.data;
                _this2.plants = data.plants;
                _this2.errors = data.errors;
                _this2.fetchedAt = data.fetchedAt;
                _this2.stale = data.stale;
                _this2.daytime = data.daytime !== false;
                _this2.detail = {};
                _context.next = 17;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);
                _this2.errors = [{
                  msg: '資料讀取失敗，請洽資訊人員'
                }];
              case 17:
                _context.prev = 17;
                _this2.loading = false;
                return _context.finish(17);
              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 14, 17, 20]]);
      }))();
    },
    toggle: function toggle(p) {
      this.$set(this.opened, p.plantNo, !this.opened[p.plantNo]);
      if (this.opened[p.plantNo] && !this.detail[p.plantNo]) this.loadDetail(p);
    },
    loadDetail: function loadDetail(p) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$getSolarEdgePl, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$set(_this3.detailLoading, p.plantNo, true);
                _this3.$set(_this3.detailError, p.plantNo, '');
                _context2.prev = 2;
                _context2.next = 5;
                return getSolarEdgePlantInvertersApi(p.plantNo);
              case 5:
                _yield$getSolarEdgePl = _context2.sent;
                data = _yield$getSolarEdgePl.data;
                _this3.$set(_this3.detail, p.plantNo, data);
                _context2.next = 13;
                break;
              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                _this3.$set(_this3.detailError, p.plantNo, '逆變器資料讀取失敗，請洽資訊人員');
              case 13:
                _context2.prev = 13;
                _this3.$set(_this3.detailLoading, p.plantNo, false);
                return _context2.finish(13);
              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10, 13, 16]]);
      }))();
    },
    todayChart: function todayChart(p) {
      return {
        chart: {
          height: 160,
          spacing: [6, 4, 2, 0],
          backgroundColor: 'transparent'
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: p.curve.map(function (c) {
            return dayjs(c.t).format('HH:mm');
          }),
          tickInterval: Math.max(1, Math.round(p.curve.length / 8)),
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        yAxis: {
          title: {
            text: null
          },
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        tooltip: {
          valueSuffix: ' kW',
          valueDecimals: 2
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false
            }
          }
        },
        series: [{
          name: '即時發電功率 kW',
          type: 'area',
          data: p.curve.map(function (c) {
            return c.power;
          }),
          color: '#7cb5ec',
          fillOpacity: 0.25
        }]
      };
    },
    maxEnergy: function maxEnergy(inverters) {
      return Math.max.apply(Math, _toConsumableArray(inverters.map(function (i) {
        return i.energy || 0;
      })).concat([1]));
    },
    fmt: function fmt(v) {
      var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return v == null ? '—' : Number(v).toFixed(digits);
    },
    pct: function pct(v, max) {
      if (!v || !max) return '0%';
      return "".concat(Math.min(100, v / max * 100).toFixed(1), "%");
    }
  },
  mounted: function mounted() {
    this.load();
  }
};